angular.module('tgaAdmin')
  .controller('PlayerPrizeController', ['$scope', '$uibModalInstance', '$filter', 'hubService', 'prize',
    function ($scope, $uibModalInstance, $filter, hubService, prize) {
      $scope.data = angular.copy(prize);

      $scope.countupOptions = {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: ':',
      };

      $scope.viewmodel = {};

      $scope.initialize = function () {
        if (prize) {
          // $scope.viewmodel.avgTime = parseFloat($filter('formatDuration')(prize.total_time).replace(':', '.'));
          // $scope.viewmodel.reward_total = prize.reward_total;
          // $scope.viewmodel.total_sessions = prize.total_sessions;
        }
      };

      $scope.actions = {
        ok(data) {
          $uibModalInstance.close(data);
        },
        cancel(data) {
          $uibModalInstance.dismiss(data);
        },
      };

      $scope.initialize();
    },
  ]);
